import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import styles from './styles/Header.module.css';

// Frontend Components
import './App.css';  // Your frontend CSS
import Header from './components/Header';
import Footer from './components/Footer';
import CustomerSupport from './components/admin/layout/CustomerSupport/CustomerSupport';
import Home from './pages/Home';
import About from './pages/aboutUs/About.js';
import Contact from './pages/aboutUs/Contact.js';
import E_card from './pages/ecards/E_card.js';
import CardDetails from './pages/ecards/CardDetails.js';
import Gharama from './pages/aboutUs/Gharama.js';
import TermsAndConditions from './pages/aboutUs/TermsAndConditions.js';
import Awards from './pages/aboutUs/Awards.js';
import WatoaHuduma from './pages/WatoaHuduma/WatoaHuduma.js';
import WatoaHudumaByCategory from './pages/WatoaHuduma/WatoaHudumaByCategory';
import Events from './pages/Events/Events.js';

import WatoaHudumaDetails from './pages/WatoaHuduma/WatoaHudumaDetails.js';

import LoginSignup from './pages/LoginSignup/LoginSignup.js';
import ForgotPassword from './pages/LoginSignup/ForgotPassword';

import EventWebsite from './pages/EventWebsite/EventWebsite';
import ProtectedRoute from './components/ProtectedRoute';
import WatoaHudumaRoutes from './components/WatoaHuduma_admin_panel/WatoaHudumaRoutes';

import MaintenancePage from './components/errors/MaintenancePage';
import Error404 from './components/errors/Error404';

// Component to dynamically set document title per route
const PageTitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    const titles = {
      '/Home': 'Home | Harusi Online - Mfumo wa Kidigitali wa Matukio',
      '/home': 'Home | Harusi Online - Mfumo wa Kidigitali wa Matukio',
      '/about': 'About Us | Harusi Online',
      '/About': 'About Us | Harusi Online',
      '/contact': 'Contact Us | Harusi Online',
      '/Contact': 'Contact Us | Harusi Online',
      '/e_card': 'E-Cards | Harusi Online - Kadi za Kidigitali',
      '/gharama': 'Bei na Gharama | Harusi Online',
      '/Gharama': 'Bei na Gharama | Harusi Online',
      '/TermsAndConditions': 'Terms & Conditions | Harusi Online',
      '/awards': 'Tuzo na Shukurani | Harusi Online',
      '/Awards': 'Tuzo na Shukurani | Harusi Online',
      '/newsletter': 'Tuzo na Shukurani | Harusi Online',
      '/WatoaHuduma': 'Watoa Huduma | Harusi Online',
      '/watoahuduma': 'Watoa Huduma | Harusi Online',
      '/Events': 'Matukio | Harusi Online',
      '/events': 'Matukio | Harusi Online',
      '/login': 'Ingia / Jisajili | Harusi Online',
      '/forgot-password': 'Badili Nenosiri | Harusi Online',
      '/maintenance': 'Matengenezo | Harusi Online',
    };

    if (titles[path]) {
      document.title = titles[path];
    } else if (path.startsWith('/card-details/')) {
      document.title = 'Taarifa za Kadi | Harusi Online';
    } else if (path.startsWith('/watoa-huduma/category/')) {
      document.title = 'Watoa Huduma kwa Jamii | Harusi Online';
    } else if (path.startsWith('/watoa-huduma-details/')) {
      document.title = 'Taarifa za Mtoa Huduma | Harusi Online';
    } else if (path.startsWith('/event-website/')) {
      document.title = 'Tovuti ya Tukio | Harusi Online';
    } else if (path.startsWith('/service-provider')) {
      document.title = 'Mtoa Huduma Admin Panel | Harusi Online';
    } else {
      document.title = 'Harusi Online - Mfumo wa Kidigitali wa Matukio';
    }
  }, [location]);

  return null;
};

function UserApp() {
  return (
    <>
      <PageTitleManager />
      <Routes>
        <Route path="/event-website/:slug" element={<EventWebsite />} />

        <Route path="/service-provider/*" element={
          <ProtectedRoute providerOnly={true}>
            <WatoaHudumaRoutes />
          </ProtectedRoute>
        } />

        <Route path="*" element={
          <div className="App">
            <Header />
            <main className={styles.mainContent}>
              <Routes>
                {/* Redirect root URL / to /Home */}
                <Route path="/" element={<Navigate to="/Home" replace />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/home" element={<Navigate to="/Home" replace />} />
                <Route path="/about" element={<About />} />
                <Route path="/About" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/e_card" element={<E_card />} />
                <Route path="/card-details/:id" element={<CardDetails />} />
                <Route path="/gharama" element={<Gharama />} />
                <Route path="/Gharama" element={<Gharama />} />
                <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
                <Route path="/awards" element={<Awards />} />
                <Route path="/Awards" element={<Awards />} />
                <Route path="/newsletter" element={<Navigate to="/awards" replace />} />
                <Route path="/WatoaHuduma" element={<WatoaHuduma />} />
                <Route path="/watoa-huduma/category/:id" element={<WatoaHudumaByCategory />} />
                <Route path="/watoa-huduma-details/:id" element={<WatoaHudumaDetails />} />
                <Route path="/Events" element={<Events />} />
                <Route path="/events" element={<Events />} />

                <Route path="/login" element={<LoginSignup />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />

                {/* Maintenance route */}
                <Route path="/maintenance" element={<MaintenancePage />} />

                {/* 404 route should always be last */}
                <Route path="*" element={<Error404 />} />
              </Routes>
            </main>
            <Footer />
            <CustomerSupport />
          </div>
        } />
      </Routes>
    </>
  );
}

export default UserApp;
